import { AnyAction } from 'redux'
import { Observable, EMPTY, of } from 'rxjs'
import {
    ACTION_LOAD_ERP_TRANSFER_STATISTICS,
    actionLoadErpTransferStatisticsSuccess,
    ACTION_SET_ERP_TRANSFER_STATISTICS_FINISHED,
    actionSetErpTransferFinishedSuccess,
} from './erp-statistic-actions'
import { flatMap, map, withLatestFrom, mergeMap, concatMap, filter } from 'rxjs/operators'
import { combineEpics, ofType } from 'redux-observable'
import { defaultCatchError } from '../app/app-epics'
import DashboardClient from 'clients/dashboard-client'

export const loadErpTransferStatistics = (action$: Observable<AnyAction>, state$: Observable<any>) => {
    return action$.pipe(
        ofType(ACTION_LOAD_ERP_TRANSFER_STATISTICS),
        withLatestFrom(state$),
        flatMap(
            ([action, state]): Observable<AnyAction> =>
                DashboardClient.getErpTransferStatistics(action.year, action.id).pipe(
                    map((result) => actionLoadErpTransferStatisticsSuccess(result)),
                    defaultCatchError(),
                ),
        ),
    )
}

export const setErpTransferStatisticsFinished = (action$: Observable<AnyAction>, state$: Observable<any>) => {
    return action$.pipe(
        ofType(ACTION_SET_ERP_TRANSFER_STATISTICS_FINISHED),
        withLatestFrom(state$),
        flatMap(
            ([action, state]): Observable<AnyAction> =>
                DashboardClient.setErpTransferStatisticsFinished(action.statistics).pipe(
                    map((result) => actionSetErpTransferFinishedSuccess(result)),
                    defaultCatchError(),
                ),
        ),
    )
}

export const invoiceErpTransferStatisticsEpics = combineEpics(
    loadErpTransferStatistics,
    setErpTransferStatisticsFinished,
)
